import React, { useEffect, useState } from "react";
import {
  Wrap,
  Tab,
  TabButton,
  ListWrapper,
  List,
  ListItem,
  DisplayTime,
  Event,
  TeamLogo,
  Text,
  TextContainer,
  TextWrapper,
} from "./styled";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react";
import SportsTeamLogo from "../../../teamLogo";
import FootballBroadcastStore from "../../../../store/score/BroadcastStore/football";

const FootBallBroadCast = observer(({ gameData }) => {
  const { detail } = gameData;
  const { period, teams } = detail;

  const { id } = useParams();
  const [active, setActive] = useState(0);

  const { broadcast, getBroadcast, closeSocket } = FootballBroadcastStore(id);
  useEffect(() => {
    getBroadcast(id);
    return () => {
      closeSocket();
    };
  }, []);

  let broadcastComps = [];
  if (broadcast !== null) {
    for (let [key, value] of Object.entries(broadcast)) {
      if (active === 0) {
        broadcastComps.unshift(
          <ListComp key={key} data={value} teams={teams} />
        );
      } else {
        if (parseInt(key) === active) {
          broadcastComps.unshift(
            <ListComp key={key} data={value} teams={teams} />
          );
        }
      }
    }
  }

  return (
    <Wrap>
      <Tab>
        <div>
          <TabButton
            active={active === 0}
            onClick={() => setActive(0)}
            disabled={false}
          >
            전체
          </TabButton>
          <TabButton
            active={active === 1}
            onClick={() => setActive(1)}
            disabled={period < 1}
          >
            1Q
          </TabButton>
          <TabButton
            active={active === 2}
            onClick={() => setActive(2)}
            disabled={period < 2}
          >
            2Q
          </TabButton>
          <TabButton
            active={active === 3}
            onClick={() => setActive(3)}
            disabled={period < 3}
          >
            3Q
          </TabButton>
          <TabButton
            active={active === 4}
            onClick={() => setActive(4)}
            disabled={period < 4}
          >
            4Q
          </TabButton>
          <TabButton
            active={active === 5}
            onClick={() => setActive(5)}
            disabled={period < 5}
          >
            연장
          </TabButton>
        </div>
      </Tab>
      <ListWrapper>{broadcastComps}</ListWrapper>
    </Wrap>
  );
});

const ListComp = ({ data, teams }) => {
  return (
    <List>
      {data.map((value, key) => {
        return <ListItemComp data={value} teams={teams} />;
      })}
    </List>
  );
};

const teamNameState = {
  HOME: "",
  AWAY: "",
};

const broadcastTypeToGoalClassName = {
  NORMAL: "",
  TOUCH_RUN: "goal",
  TOUCH_PASS: "goal",
  EXTRA_POINT: "goal",
  PIELD_GOAL: "goal",
  PIELD_FAIL: "no_goal",
  TOUCH: "goal",
  TEXT: "",
};
const ListItemComp = ({ data, teams }) => {
  const {
    displayTime,
    locationType,
    playerName,
    broadcastType,
    subPlayText,
    playText,
  } = data;

  const [teamImages, setTeamImages] = useState(teamNameState);
  useEffect(() => {
    let teamData = teams;
    if (teamData !== undefined) {
      setTeamImages({
        HOME: teamData.home.imgPath,
        AWAY: teamData.away.imgPath,
      });
    }
  }, [teams]);
  const isNotice = locationType === "TOTAL";
  const teamImage =
    (locationType !== "TOTAL" && teamImages[locationType]) || "";
  const isNormalType = broadcastType === "NORMAL" || broadcastType === "TEXT";
  return (
    <ListItem>
      <DisplayTime>{displayTime}</DisplayTime>
      <TextContainer>
        <TextWrapper isNotice={isNotice}>
          {!isNotice && (
            <TeamLogo>
              {teamImage !== "" && (
                <SportsTeamLogo
                  imgSize={"23"}
                  imgUrl={teamImage}
                  isLazy={true}
                />
              )}
            </TeamLogo>
          )}
          <Event>
            <em className={`${broadcastTypeToGoalClassName[broadcastType]}`} />
          </Event>
          <Text>
            {isNormalType ? (
              <>
                {playerName} {playText}
              </>
            ) : (
              <>
                {playerName} {subPlayText}
              </>
            )}
            <em>{subPlayText}</em>
          </Text>
        </TextWrapper>
      </TextContainer>
    </ListItem>
  );
};
export default FootBallBroadCast;
